import { Spin } from 'antd';
import { FC } from 'react';

export const FullScreenLoader: FC = () => {
    return (
        <div className="absolute inset-0 flex h-full w-full items-center justify-center bg-white/50 dark:bg-black/50">
            <Spin />
        </div>
    );
};
